import styled from 'styled-components';
import { BLACK, NEUTRAL_100, VIOLET_700 } from '../../styles/colors';
import { GIVONIC, INTER } from '../../styles/fonts';

export const DialogContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  padding: 16px;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: ${NEUTRAL_100};
  border-radius: 12px;
  width: 100%;
`;

export const DialogHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
  margin-top: 8px;
`;

export const DialogTitle = styled.span`
  font-size: 18px;
  font-family: ${GIVONIC.bold};
  color: ${VIOLET_700};
`;

export const DialogDescription = styled.span`
  font-size: 13px;
  font-family: ${INTER.regular};
  color: ${BLACK};
`;

export const DialogActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
